import { createStandardAction } from 'typesafe-actions'
import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import { DRUGS_URL } from '../../constants/urls/backend'
import { IDrug } from '../../types/drug'
import { apiRoute } from '../../utils/routeUtils'
import { axiosWithAdal } from '../../utils/http'

const drugsSuccess = createStandardAction('@@drugs/SUCCESS')<IDrug[]>()
const drugsError = createStandardAction('@@drugs/ERROR')<string[]>()
const drugsRequest = createStandardAction('@@drugs/REQUEST')()

interface IResponse {
  id: number
  module: string
  name: string
}

const fetchDrugs = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
    dispatch(drugsRequest())
    try {
      const response = await axiosWithAdal.get<IResponse[]>(apiRoute(DRUGS_URL), {
        headers: {
          'Content-Type': 'application/json',
        }
      })

      const payload: IDrug[] = response.data.map(x => {
        return {
          id: x.id,
          module: x.module,
          name: x.name,
        }
      })

      dispatch(drugsSuccess(payload))
    } catch (e) {
      dispatch(drugsError([ e.message ]))
      return
    }
  }
}

export {
  drugsSuccess,
  drugsRequest,
  drugsError,
  fetchDrugs,
}
